<app-notification *ngIf="errorMessage" locked=true error="true" display="true" timeOut="0" content="{{errorMessage}}"></app-notification>

<div [ngClass]="{'disabled': files.length >= maxNumberOfFiles}" class="uploadfilecontainer" (click)="fileInput.value='';fileInput.click()" appDropzone (onFileDropped)="uploadFile($event)">
  <input hidden type="file" accept="{{generateAcceptString(allowedInputs)}}" #fileInput (change)="uploadFile($event.target.files)">
  <div class="dropzone-body" style="margin: auto; text-align: center; width: 100%">
    <img *ngIf="dropzoneImage" [src]="dropzoneImage" alt="Dropzone Image">
    <p style="color: #35566E;font-size: 20px;padding-top: 5px" [innerHTML]="dropzoneText"></p>
  </div>
</div>
<div class="files-list" *ngFor="let file of files;let i= index">
  <p *ngIf="file.name.length < 35;else elseBlock"> {{file.name}}</p>
  <ng-template #elseBlock>
    <p matTooltip="{{file.name}}" [matTooltipPosition]="'above'">{{file.name.slice(0,30)}}...</p>
  </ng-template>
  <button class="delete" (click)="deleteAttachment(i)">
  </button>
</div>
